module.exports = __webpack_public_path__ + "static/line_01-a2056a5da624f457afd42d3774dada73.png";